import { useState } from "react";
import type { ReactNode } from "react";

/**
 * Uygulamanın kendi logosu. Dosyalar public/app-icons/<id>.png (128 px'e
 * küçültülmüş; kaynakları app.json → icon, Discord botu için RAADIO TR logosu).
 * Logosu olmayan yeni bir uygulama baş harfli, adından türetilen renkte bir
 * kutucuk alır — boş bir 404 isteği atılmasın diye bilinen liste burada.
 */
const ICONS = new Set([
  "movieport",
  "raadiocast",
  "stockanalyzer",
  "dailyguess",
  "cinderpath",
  "raadiotr",
  // Discord botları tek tek (Bot sayfası): pm2 süreç adı → bot-<süreç>.png
  "bot-raadiotr",
  "bot-raadiotr2",
]);

export function AppIcon({
  id,
  name,
  size = 20,
  className = "",
}: {
  id: string;
  /** Harfli yedek için. */
  name?: string;
  size?: number;
  className?: string;
}): ReactNode {
  const [broken, setBroken] = useState(false);
  const radius = Math.round(size * 0.24);

  if (ICONS.has(id) && !broken) {
    return (
      <img
        src={`/app-icons/${id}.png`}
        alt=""
        aria-hidden
        width={size}
        height={size}
        onError={() => setBroken(true)}
        className={`shrink-0 object-cover ${className}`}
        style={{ width: size, height: size, borderRadius: radius, boxShadow: "0 0 0 1px rgba(255,255,255,0.06)" }}
      />
    );
  }

  const label = (name ?? id).replace(/[^\p{L}\p{N}]/gu, "").slice(0, 2).toUpperCase() || "?";
  const hue = [...id].reduce((h, c) => (h * 31 + c.charCodeAt(0)) % 360, 7);
  return (
    <span
      aria-hidden
      className={`inline-grid shrink-0 place-items-center font-semibold ${className}`}
      style={{
        width: size,
        height: size,
        borderRadius: radius,
        fontSize: Math.max(9, Math.round(size * 0.4)),
        color: `hsl(${hue} 80% 85%)`,
        background: `hsl(${hue} 35% 26%)`,
        boxShadow: "0 0 0 1px rgba(255,255,255,0.06)",
      }}
    >
      {label.charAt(0)}
    </span>
  );
}
